export default __webpack_public_path__ + "static/media/13.57731d39.PNG";